<template>
  <div class="m-5">
    <d-table class="mt-10" :data="groups" detailed :loading="loadingGroups" paginated striped detail-key="id" default-sort-direction="asc" show-search :per-page="10" :search.sync="filter">
      <template #action-buttons>
        <h2 class=" text-primary-500 mb-0">
          Groups
        </h2>
      </template>
      <template #action-buttons-right>
        <d-btn class="" @click="launchGroupsModal()">
          + Add Group
        </d-btn>
      </template>
      <template slot-scope="props">
        <d-table-column field="name" :row="props.row" label="Group Name" sortable>
          <b> {{ props.row.name }} </b>
        </d-table-column>
        <d-table-column field="autoGenerated" :row="props.row" label="Auto Generated" sortable>
          <d-checkbox v-model="props.row.autoGenerated" disabled />
        </d-table-column>
        <d-table-column field="description" :row="props.row" label="Description" sortable>
          {{ props.row.description }}
        </d-table-column>
        <d-table-column field="memberCount" :row="props.row" label="Member Count" sortable>
          {{ props.row.memberCount }}
        </d-table-column>
        <d-table-column class="text-right">
          <d-icon icon="envelope" class="cursor-pointer ml-4" @click.native="launchNotificationsModal(props.row)" />
        </d-table-column>
        <d-table-column v-if="!props.row.autoGenerated" class="text-right" label="">
          <div class="flex">
            <d-icon icon="edit" class="cursor-pointer text-green-500 ml-4" @click.native="launchEditGroupsModal(props.row)" />
            <d-icon icon="trash" class="cursor-pointer text-primary-500 ml-4" @click.native="deleteGroup(props.row)" />
          </div>
        </d-table-column>
        <d-table-column v-else />
      </template>

      <template slot="detail" slot-scope="props">
        <mentor-group-members-grid :group="props.row" />
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import ViewNotificationModal from '@resources/scripts/patterns/ViewNotificationModal.vue';
  import MentorGroupsModal from './components/MentorGroupsModal.vue';

  export default {
    parent: true,

    data: () => ({
      groups: [],
      loadingGroups: false,
      filter: '',
    }),

    mounted() {
      this.getMentorGroups();
    },

    methods: {
      async getMentorGroups() {
        this.loadingGroups = true;
        const { data } = await axios.get('/api/mentor/groups');
        this.groups = data;
        this.loadingGroups = false;
      },
      gotoNotificationsPage(group) {
        window.location = `/system/notifications?type=group&entityId=${group.id}`;
      },
      launchGroupsModal() {
        this.$modal.open({
          parent: this,
          component: MentorGroupsModal,
          hasModalCard: true,
          events: {
            getMentorGroups: () => this.getMentorGroups(),
          },
        });
      },

      launchNotificationsModal(group) {
        this.$modal.open({
          parent: this,
          component: ViewNotificationModal,
          hasModalCard: true,
          props: {
            entityId: group.id,
            type: 'group',
            name: group.name,
          },
        });
      },

      launchEditGroupsModal(group) {
        this.$modal.open({
          parent: this,
          component: MentorGroupsModal,
          hasModalCard: true,
          props: {
            group,
          },
          events: {
            getMentorGroups: () => this.getMentorGroups(),
          },
        });
      },

      async deleteGroup(group) {
        this.$dialog.confirm({
          title: 'Deleting Group',
          message: `Are you sure you want to <b>delete</b> ${group.name}? This action cannot be undone.`,
          confirmText: 'Delete Group',
          confirmColor: 'red-500',
          onConfirm: async () => {
            await axios.delete(`/api/mentor/groups/${group.id}`);
            this.getMentorGroups();
            this.$toast.open('Group deleted!');
          },
        });
      },

    },

  };
</script>
